exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.uk-grid > *[data-v-29bf5125]{\n    padding-left: 2vw;\n}\n", ""]);

// exports
